import React, {useMemo} from "react";

import {Col} from "@pg-design/grid-module";

import {ISelectedRegion} from "../../../offer/list/actions/offer_list_selected_data_actions";
import {disableDynamicPositionProps} from "../../../offer/list/hooks/use_list_dynamic_positions";
import {useGetReelsListQuery} from "../../api/get_reels_list";
import {ReelList} from "./ReelList";

interface IProps {
    selectedRegions: ISelectedRegion[];
    onReelsModalClose?: () => void;
    className?: string;
}

export const ListingReels = (props: IProps) => {
    const selectedRegionIds = useMemo(() => props.selectedRegions?.map((region) => region.id), [props.selectedRegions]);
    const {data, isLoading} = useGetReelsListQuery({regionIds: selectedRegionIds});

    if (!isLoading && data?.count === 0) {
        return null;
    }

    return (
        <Col sm={4} md={12} lg={16} as="li" {...disableDynamicPositionProps()} className={props.className}>
            <ReelList onAfterModalClose={props.onReelsModalClose} selectedRegions={props.selectedRegions} />
        </Col>
    );
};
import React, {useMemo} from "react";

import {Col} from "@pg-design/grid-module";

import {ISelectedRegion} from "../../../offer/list/actions/offer_list_selected_data_actions";
import {disableDynamicPositionProps} from "../../../offer/list/hooks/use_list_dynamic_positions";
import {useGetReelsListQuery} from "../../api/get_reels_list";
import {ReelList} from "./ReelList";

interface IProps {
    selectedRegions: ISelectedRegion[];
    onReelsModalClose?: () => void;
    className?: string;
}

export const ListingReels = (props: IProps) => {
    const selectedRegionIds = useMemo(() => props.selectedRegions?.map((region) => region.id), [props.selectedRegions]);
    const {data, isLoading} = useGetReelsListQuery({regionIds: selectedRegionIds});

    if (!isLoading && data?.count === 0) {
        return null;
    }

    return (
        <Col sm={4} md={12} lg={16} as="li" {...disableDynamicPositionProps()} className={props.className}>
            <ReelList onAfterModalClose={props.onReelsModalClose} selectedRegions={props.selectedRegions} />
        </Col>
    );
};
